import { PropsWithChildren, useState, useMemo, useCallback } from 'react';
import { createSafeContext } from '@mews/framework';
import { ProductSidePanelTabValues } from '../tables/CentralProductTable/types';
import { CentralProductSidePanel } from './CentralProductSidePanel';

interface SidePanelContextType {
    open: (id: string, tab: ProductSidePanelTabValues, propertyIds: string[]) => void;
    close: () => void;
}

const { CentralProductSidePanelContextProvider: ContextProvider, useCentralProductSidePanelContext } =
    createSafeContext<'CentralProductSidePanelContext', SidePanelContextType>('CentralProductSidePanelContext');

export const CentralProductSidePanelContextProvider = ({ children }: PropsWithChildren<{}>) => {
    const [initialSidePanelTab, setInitialSidePanelTab] = useState<ProductSidePanelTabValues>(
        ProductSidePanelTabValues.Details
    );
    const [selectedId, setSelectedId] = useState<string>();

    const closeSidePanel = useCallback(() => {
        setSelectedId(undefined);
        setInitialSidePanelTab(ProductSidePanelTabValues.Details);
    }, []);

    const contextValue = useMemo(
        () => ({
            open: (id: string, tab: ProductSidePanelTabValues) => {
                setSelectedId(id);
                setInitialSidePanelTab(tab);
            },
            close: closeSidePanel,
            initialTab: initialSidePanelTab,
        }),
        [closeSidePanel, initialSidePanelTab]
    );

    return (
        <ContextProvider value={contextValue}>
            {children}
            <CentralProductSidePanel
                centralProductId={selectedId}
                closeSidePanel={closeSidePanel}
                initialTab={initialSidePanelTab}
            />
        </ContextProvider>
    );
};

export { useCentralProductSidePanelContext };
